import type { CSSObject } from "@emotion/react"

export const globalStyles: CSSObject = {
  a: {
    color: "inherit",
    textDecoration: "none",
  },
}
